<template>
  <v-app id="inspire" standalone>
    <v-navigation-drawer app persistent dark v-model="drawer" v-if="authenticated">
      <v-toolbar flat class="teal">
        <v-list-tile-action style="margin-right:15px">
          <v-icon x-large>account_circle</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title class="white--text">{{ role }}</v-list-tile-title>
          <v-list-tile-sub-title class="white--text">{{ login }}</v-list-tile-sub-title>
        </v-list-tile-content>
      </v-toolbar>
      <v-divider></v-divider>
      <v-list dense expand>
        <template v-for="(item, i) in menus">
          <!--group with subitems-->
          <v-list-group
            v-if="item.items"
            v-show="menuCan(item)"
            :key="item.name"
            :group="item.group"
            :prepend-icon="item.icon"
            no-action="no-action"
          >
            <v-list-tile slot="activator" ripple="ripple">
              <v-list-tile-content>
                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <template v-for="(subItem, i) in item.items">
              <!--sub group-->
              <v-list-group
                v-if="subItem.items"
                v-show="menuCan(subItem, item.group)"
                :key="subItem.name"
                :group="subItem.group"
                sub-group="sub-group"
              >
                <v-list-tile slot="activator" ripple="ripple">
                  <v-list-tile-content>
                    <v-list-tile-title>{{ subItem.title }}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile
                  v-for="(grand, i) in subItem.children"
                  v-show="menuCan(grand, subItem.group)"
                  :key="i"
                  :to="genChildTarget(item, grand)"
                  :href="grand.href"
                  ripple="ripple"
                >
                  <v-list-tile-content>
                    <v-list-tile-title>{{ grand.title }}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list-group>
              <!--child item-->
              <v-list-tile
                v-else
                v-show="menuCan(subItem, item.group)"
                :key="i"
                :to="genChildTarget(item, subItem)"
                :href="subItem.href"
                :disabled="subItem.disabled"
                :target="subItem.target"
                ripple="ripple"
              >
                <v-list-tile-avatar v-if="subItem.icon">
                  <v-icon>{{ subItem.icon }}</v-icon>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title>
                    <span>{{ subItem.title }}</span>
                  </v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action v-if="subItem.action">
                  <v-icon :class="[subItem.actionClass || 'success--text']">{{ subItem.action }}</v-icon>
                </v-list-tile-action>
              </v-list-tile>
            </template>
          </v-list-group>
          <v-subheader v-else-if="item.header" :key="i">{{ item.header }}</v-subheader>
          <v-divider v-else-if="item.divider" :key="i"></v-divider>
          <!--top-level link-->
          <v-list-tile
            v-else
            v-show="menuCan(item)"
            :to="!item.href ? { name: item.name } : null"
            :href="item.href"
            ripple="ripple"
            :disabled="item.disabled"
            :target="item.target"
            rel="noopener"
            :key="item.name"
          >
            <v-list-tile-action v-if="item.icon">
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action v-if="item.subAction">
              <v-icon class="success--text">{{ item.subAction }}</v-icon>
            </v-list-tile-action>
          </v-list-tile>
        </template>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar fixed app class="indigo darken-4" dark>
      <v-toolbar-side-icon v-on:click="drawer = !drawer" v-if="authenticated"></v-toolbar-side-icon>
      <v-toolbar-title>TopUp Admin Panel</v-toolbar-title>
      <v-spacer></v-spacer>
      <template v-if="screenWidth>500">
        <v-btn flat @click.native="logout()" v-if="authenticated">Logout</v-btn>
      </template>
      <template v-else>
        <v-btn @click.native="logout()" icon v-if="authenticated">
          <v-icon color="white">fa-sign-out</v-icon>
        </v-btn>
      </template>
    </v-toolbar>
    <v-content>
      <v-container fluid grid-list-xl>
        <transition name="slide-fade">
          <router-view/>
        </transition>
      </v-container>
    </v-content>
    <v-footer height="auto" inset color="indigo darken-4" style="margin-top:15px">
      <v-layout justify-center row wrap>
        <v-flex text-xs-center white--text xs12 body-2>
          &copy;2018 —
          <strong>V:1.1.11 D:4:31 PM</strong>
        </v-flex>
      </v-layout>
    </v-footer>
  </v-app>
</template>

<script>
import router from "@/router";
import { mapState, mapActions, mapMutations } from "vuex";
import AppEvents from "../event";
import menu from "@/api/menu";

export default {
  name: "app",
  data() {
    return {
      menus: menu,
      drawer: true,
      mini: false,
      right: null
    };
  },
  watch: {
    drawer: {
      handler(val) {
        console.log(val);
      }
    },
    error(val) {
      if (val.statusCode === 403) {
        this.$router.push({ name: "403" });
      }
    },
    abilities(val) {
      this.setAbilities(val);
    }
  },
  mounted() {
    this.$store.dispatch("checkAuth");
  },
  created() {
    AppEvents.forEach(item => {
      this.$on(item.name, item.callback);
    });
    window.getApp = this;
    this.setAbilities(this.$store.state.abilities);
  },

  computed: {
    ...mapState({
      role: "role",
      permissions: "permissions",
      authenticated: "authenticated",
      login: "login",
      error: "error",
      abilities: "abilities"
    }),

    screenWidth() {
      return document.documentElement.clientWidth;
    }
  },
  methods: {
    menuCan(item, group) {
      let { name, component, href, items } = item;
      let uri = {};
      if (href) {
        uri.to = href;
      } else if (component) {
        uri.name = component;
      } else if (group && name) {
        uri.name = `${group}/${name}`;
      } else if (name) {
        uri.name = name;
      } else if (item.items) {
        //return false;
        return (
          item.items.map(i => this.menuCan(i, item.group)).filter(i => i)
            .length > 0
        );
      } else return false;
      let {
        route: { meta }
      } = this.$router.resolve(uri);
      return (
        meta.hasOwnProperty("can") &&
        (typeof meta.can == "string" ? this.$can("read", meta.can) : meta.can)
      );
    },
    genChildTarget(item, subItem) {
      if (subItem.href) return;
      if (subItem.component) {
        return {
          name: subItem.component
        };
      }
      return { name: `${item.group}/${subItem.name}` };
    },
    setAbilities(val) {
      this.$ability.update([]);
      this.$ability.update(val);
    },
    ...mapActions(["logout"]),

    navigate(url) {
      if (url != "" && url != undefined) {
        console.log(url);
        this.$router.push(url);
      }
    }
  }
};
</script>
  <style scope>
.slide-fade-enter-active {
  transition: all 0.5s ease;
}

.slide-fade-leave-active {
  display: none;
}

body::-webkit-scrollbar {
  display: none;
}

.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}

.list__tile__action {
  min-width: 36px !important;
}

.list--group .list__tile,
.v-list__group__items .v-list__tile {
  padding-left: 56px;
}
</style>




// WEBPACK FOOTER //
// App.vue?090de20c